// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./physee-semantic-ui/semantic.less
// module id = 487
// module chunks = 0